import type { EffectiveServiceOffering } from "@/lib/service/types";

/** Pricing-tab guidance panel — visible only when offering matched and docs exist. */
export function shouldShowOpportunityOfferingGuidancePanel(
  matchedOffering: EffectiveServiceOffering | null,
  docsLoaded: boolean,
  documentCount: number
): boolean {
  return matchedOffering != null && docsLoaded && documentCount > 0;
}
